import { render, staticRenderFns } from "./CategoryTileGrid.vue?vue&type=template&id=2aa063aa&scoped=true&"
import script from "./CategoryTileGrid.vue?vue&type=script&lang=ts&"
export * from "./CategoryTileGrid.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryTileGrid.vue?vue&type=style&index=0&id=2aa063aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa063aa",
  null
  
)

export default component.exports